import { OrdersStatusResponse } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class OrderStatus<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Abel to get a list of multiple orders status
	 *
	 * @tags Order Status
	 * @name Status
	 * @summary Get the order status and last update date of multiple
	 * @request GET:/store/{storeId}/hdm/order/{orderIds}/status
	 * @response `200` `OrdersStatusResponse` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	status = (
		storeId: string,
		orderIds: string,
		query?: {
			/**
			 * Language identifier. If not specified, the "locale" parameter is used. If "locale" is not specified, then the store default language is used.
			 * @example "-1, -2, -3, -4, -5"
			 */
			langId?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (loggerCan('trace') && (!this.http.traceDetails || this.http.traceDetails['status'])) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/order/${orderIds}/status`,
				params: _params,
				query: query,
				methodName: 'status',
			};
			logger.trace(traceData);
		}
		return this.http.request<OrdersStatusResponse, void>({
			path: `/store/${storeId}/hdm/order/${orderIds}/status`,
			method: 'GET',
			query: query,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
